module.exports = "/packs/images/svg/accessibility/accessible_parking~8ca77cccfc52b2c721d4fd6b587537f9.svg";